import { useEffect, useState } from "react";
import { ArrowRight, Clock } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { ARTICLES } from "@/data/articles";
import { IMG_KASO_SUPER, navigateTo } from "@/data/site";

export const Articles = () => {
  const [autoArts, setAutoArts] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/articles/auto`)
      .then((r) => r.json())
      .then((d) => setAutoArts(d.articles || []))
      .catch(() => {});
    const m = window.location.hash.match(/^#\/artikel\/(.+)$/);
    if (m) navigateTo(`/artikel/${m[1]}`);
  }, []);

  return (
    <section id="artikel" data-testid="articles-section" className="surface py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <SectionHead
          overline="Artikel & Panduan"
          title={<>Panduan Lengkap <span className="italic accent-text">Kayu Bekisting</span></>}
          sub="Artikel mendalam seputar harga, spesifikasi, dan tips membeli kayu kaso & balok bekisting murah di Jakarta — langsung dari distributor."
        />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {[...ARTICLES, ...autoArts].map((a, i) => (
            <Reveal key={a.id} delay={Math.min(i, 3) * 0.08}>
              <button
                onClick={() => navigateTo(`/artikel/${a.slug}`)}
                data-testid={`article-card-${a.id}`}
                className="card-surface group flex h-full w-full flex-col overflow-hidden rounded-[1.4rem] text-left transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={a.image || IMG_KASO_SUPER}
                    alt={a.keyword}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 rounded-full px-3 py-1 text-[10px] font-semibold uppercase tracking-wider text-white backdrop-blur-sm" style={{ background: a.auto ? "linear-gradient(90deg,#059669,#0D9488)" : "linear-gradient(90deg,#8B5CF6,#EF4444)" }}>
                    <Clock size={10} className="mr-1 inline" /> {a.auto ? "Artikel Baru" : "Artikel SEO"}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <p className="font-mono text-[10px] uppercase tracking-[0.18em] accent-text">{a.keyword}</p>
                  <h3 className="mt-2 font-serif text-lg font-semibold leading-snug text-brand-ink">{a.title}</h3>
                  <p className="mt-2 text-[10px] font-semibold uppercase tracking-wider text-brand-muted">Oleh PT. SINAR AL MUBAROKAH</p>
                  <p className="mt-3 line-clamp-3 text-xs leading-relaxed text-brand-muted">{a.excerpt}</p>
                  <span
                    className="mt-auto inline-flex items-center gap-2 pt-4 text-xs font-bold"
                    style={{ color: "var(--t-accent)" }}
                  >
                    Baca Selengkapnya <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
